import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["src"];
import { computed } from 'vue';
import { NAV_CHANNEL_ICONS } from '@/constants/navChannelIcons.js';
export default {
  __name: 'NavChannelIcon',
  props: {
    name: {
      type: String,
      required: true,
      validator: value => Object.prototype.hasOwnProperty.call(NAV_CHANNEL_ICONS, value)
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const iconSrc = computed(() => NAV_CHANNEL_ICONS[props.name]);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("img", {
        class: _normalizeClass(["nav-channel-icon", {
          'is-active': __props.active
        }]),
        src: iconSrc.value,
        alt: "",
        "aria-hidden": "true",
        draggable: "false"
      }, null, 10, _hoisted_1);
    };
  }
};